import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SelectField } from "@cinch-labs/design-system";
import { useCarReviewsHubTracking } from "@cinch-nx/data-tracking";
import styles from "./filters.module.css";
function onMakeChange(param) {
    var setIsLoading = param.setIsLoading, trackOnFilterChange = param.trackOnFilterChange, _isISR = param.isISR, isISR = _isISR === void 0 ? false : _isISR;
    return function(event) {
        setIsLoading(true);
        trackOnFilterChange(event.currentTarget.value, "make");
        var rawParams = {};
        if (event.currentTarget.value) {
            rawParams.make = event.currentTarget.value;
        }
        if (isISR) {
            window.location.href = "/reviews/".concat(rawParams.make);
            return;
        }
        var urlParams = new URLSearchParams(rawParams);
        window.location.href = "/reviews?".concat(urlParams.toString());
    };
}
function onModelChange(param) {
    var selectedMake = param.selectedMake, setIsLoading = param.setIsLoading, trackOnFilterChange = param.trackOnFilterChange, _isISR = param.isISR, isISR = _isISR === void 0 ? false : _isISR;
    return function(event) {
        setIsLoading(true);
        trackOnFilterChange(event.currentTarget.value, "model");
        var rawParams = {
            make: selectedMake
        };
        if (event.currentTarget.value) {
            rawParams.model = event.currentTarget.value;
        }
        if (isISR) {
            window.location.href = "/reviews/".concat(rawParams.make, "/").concat(rawParams.model);
            return;
        }
        var urlParams = new URLSearchParams(rawParams);
        window.location.href = "/reviews".concat(urlParams.toString() ? "?".concat(urlParams.toString()) : "");
    };
}
export var Filters = function(param) {
    var _selectedMake = param.selectedMake, selectedMake = _selectedMake === void 0 ? "" : _selectedMake, _selectedModel = param.selectedModel, selectedModel = _selectedModel === void 0 ? "" : _selectedModel, _makes = param.makes, makes = _makes === void 0 ? [] : _makes, _models = param.models, models = _models === void 0 ? [] : _models, isLoading = param.isLoading, setIsLoading = param.setIsLoading, _isISR = param.isISR, isISR = _isISR === void 0 ? false : _isISR;
    var trackOnFilterChange = useCarReviewsHubTracking().trackOnFilterChange;
    var selectFieldClassNames = {
        container: styles.selectContainer,
        select: styles.select
    };
    selectedMake = selectedMake !== null && selectedMake !== void 0 ? selectedMake : "";
    selectedModel = selectedModel !== null && selectedModel !== void 0 ? selectedModel : "";
    return /*#__PURE__*/ _jsxs("section", {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx(SelectField, {
                id: "make-options",
                placeholder: "All makes",
                value: selectedMake,
                disabled: isLoading,
                options: [
                    {
                        label: "All makes",
                        value: ""
                    }, 
                ].concat(_to_consumable_array(makes.map(function(make) {
                    return {
                        label: make,
                        value: make
                    };
                }))),
                label: "Filter by make",
                classNames: selectFieldClassNames,
                onChange: onMakeChange({
                    setIsLoading: setIsLoading,
                    trackOnFilterChange: trackOnFilterChange,
                    isISR: isISR
                })
            }),
            /*#__PURE__*/ _jsx(SelectField, {
                id: "model-options",
                placeholder: "All models",
                value: selectedModel,
                options: [
                    {
                        label: "All models",
                        value: ""
                    }, 
                ].concat(_to_consumable_array(models.map(function(model) {
                    return {
                        label: model,
                        value: model
                    };
                }))),
                label: "Filter by model",
                classNames: selectFieldClassNames,
                disabled: isLoading || selectedMake === "",
                onChange: onModelChange({
                    selectedMake: selectedMake,
                    setIsLoading: setIsLoading,
                    trackOnFilterChange: trackOnFilterChange,
                    isISR: isISR
                })
            })
        ]
    });
};
